const actionTypes = require('constants/actionTypes');
const Immutable = require('immutable');
import { formatText } from 'core/i18n';

const initialState = Immutable.fromJS({
    typesOfRoads: [],
    cities: [],
    countries: [],
    loadingAddresses: false,
    ibanBankEntities: [],
    isLoadingIbanBankEntities: true,
    isLoadingCountries: true,
    isLoadingCities: true,
    isLoadingAres: false,
    isLoadingTypesOfRoads: true,
    workFor: [],
    idWorkFor: '',
    isLoadingWorkFor: true,
    professionsWorkforEmployed: [],
    isLoadingProfessionsWorkforEmployed: true,
    professionsWorkforSelfEmployed: [],
    isLoadingProfessionsWorkforSelfEmployed: true,
    professionsWorkforSelfEmployedCode: [],
    isLoadingProfessionsWorkforSelfEmployedCode: true,
    showFullHomeAddress: false,
    showFullPostalAddress: false,
    cellPhoneProviders: [],
    professionalCategories: [
        {
            label: formatText('field-professionalCategories_item_1'),
            value: 1,
        },
        {
            label: formatText('field-professionalCategories_item_2'),
            value: 2,
        },
        {
            label: formatText('field-professionalCategories_item_3'),
            value: 3,
        },
    ],
    serverDate: null,
    cnaeSubCategories: [],
    isLoadingCnaeSubCategories: true,
    isLoadingCnoSubCategories: true,
    professionAllCategoriesCNO: [],
    professionAllCategoriesCNAE: [],
    professionsWorkforEmployedSC: [],
    isLoadingProfessionsWorkforEmployedSC: true,
    professionsWorkforSelfEmployedSC: [],
    isLoadingProfessionsWorkforSelfEmployedSC: true,
    professionalSectorCategories: [],
    professionalSectorList: [],
});

const optionsReducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case actionTypes.LOAD_ARES:
            return state.merge({
                isLoadingAres: action.payload,
            });
        case actionTypes.LOAD_ADDRESSES:
            return state.merge({
                loadingAddresses: action.payload,
            });
        case actionTypes.ADD_COUNTRIES:
            return state.merge({
                countries: Immutable.fromJS(action.data),
                isLoadingCountries: false,
            });
        case actionTypes.ADD_CITIES:
            return state.merge({
                cities: Immutable.fromJS(action.data),
                isLoadingCities: false,
            });

        case actionTypes.ADD_TYPES_OF_ROADS:
            return state.merge({
                typesOfRoads: Immutable.fromJS(action.data),
                isLoadingTypesOfRoads: false,
            });

        case actionTypes.ADD_IBANBANKENTITIES:
            var ibanBankEntities = state.get('ibanBankEntities');

            action.data.map(function (values) {
                ibanBankEntities = ibanBankEntities.push(
                    Immutable.Map({
                        id: values.id,
                        entity: values.entidad,
                        bic: values.bic,
                    })
                );
            });

            return state.merge({
                ibanBankEntities,
                isLoadingIbanBankEntities: false,
            });

        case actionTypes.ADD_WORK_FOR:
            var workFor = state.get('workFor');

            action.data.map(function (values) {
                workFor = workFor.push(
                    Immutable.Map({
                        value: values.id,
                        label: values.description,
                    })
                );
            });

            return state.merge({
                workFor,
                isLoadingWorkFor: false,
            });

        case actionTypes.ADD_PROFESSIONS_WORK_FOR_EMPLOYED:
            var professionsWorkforEmployed = state.get('professionsWorkforEmployed');

            action.data.map(function (value) {
                professionsWorkforEmployed = professionsWorkforEmployed.push(
                    Immutable.Map({
                        code: value.id,
                        name: value.description,
                    })
                );
            });

            return state.merge({
                professionsWorkforEmployed,
                isLoadingProfessionsWorkforEmployed: false,
            });

        case actionTypes.ADD_PROFESSIONS_WORK_FOR_SELFEMPLOYED:
            var professionsWorkforSelfEmployed = state.get('professionsWorkforSelfEmployed');

            action.data.map(function (value) {
                professionsWorkforSelfEmployed = professionsWorkforSelfEmployed.push(
                    Immutable.Map({
                        code: value.id,
                        name: value.description,
                    })
                );
            });

            return state.merge({
                professionsWorkforSelfEmployed,
                isLoadingProfessionsWorkforSelfEmployed: false,
            });

        case actionTypes.ADD_PROFESSIONS_WORK_FOR_SELFEMPLOYED_CODE:
            var professionsWorkforSelfEmployedCode = state.get('professionsWorkforSelfEmployedCode');

            action.data.map(function (value) {
                professionsWorkforSelfEmployedCode = professionsWorkforSelfEmployedCode.push(
                    Immutable.Map({
                        code: value.id,
                        name: value.id + ' - ' + value.description,
                    })
                );
            });

            return state.merge({
                professionsWorkforSelfEmployedCode,
                isLoadingProfessionsWorkforSelfEmployedCode: false,
            });

        case actionTypes.ADD_PROFESSIONS_WORK_FOR_EMPLOYED_SUBCATEGORIES:
            var professionsWorkforEmployedSC = state.get('professionsWorkforEmployedSC');

            action.data.map(function (value) {
                professionsWorkforEmployedSC = professionsWorkforEmployedSC.push(
                    Immutable.Map({
                        code: value.id,
                        name: value.description,
                    })
                );
            });

            return state.merge({
                professionsWorkforEmployedSC,
                isLoadingProfessionsWorkforEmployedSC: false,
            });

        case actionTypes.ADD_PROFESSIONS_WORK_FOR_SELFEMPLOYED__SUBCATEGORIES:
            var professionsWorkforSelfEmployedSC = state.get('professionsWorkforSelfEmployedSC');

            action.data.map(function (value) {
                professionsWorkforSelfEmployedSC = professionsWorkforSelfEmployedSC.push(
                    Immutable.Map({
                        code: value.id,
                        name: value.id + ' - ' + value.description,
                    })
                );
            });

            return state.merge({
                professionsWorkforSelfEmployedSC,
                isLoadingProfessionsWorkforSelfEmployedSC: false,
            });

        case actionTypes.GET_PROFESSION_SECTOR_CATEGORIES:
            let professionalSectorCategories = state.get('professionalSectorCategories');
            action.data.map(value => {
                professionalSectorCategories = professionalSectorCategories.push(
                    Immutable.Map({
                        value: value.id,
                        label: value.description,
                    })
                );
            });
            return state.merge({
                professionalSectorCategories,
            });

        case actionTypes.GET_PROFESSION_SECTOR:
            let professionalSectorList = state.get('professionalSectorList');
            action.data.map(value => {
                professionalSectorList = professionalSectorList.push(
                    Immutable.Map({
                        value: value.id,
                        label: value.description,
                    })
                );
            });
            return state.merge({
                professionalSectorList,
            });

        case actionTypes.CLEAR_PROFESSION_SECTOR:
            return state.merge({
                professionalSectorList: [],
            });

        case actionTypes.SHOW_FULL_HOME_ADDRESS:
            return state.merge({
                showFullHomeAddress: true,
            });

        case actionTypes.SHOW_FULL_POSTAL_ADDRESS:
            return state.merge({
                showFullPostalAddress: true,
            });

        case actionTypes.SERVER_DATE:
            return state.merge({
                serverDate: action.date,
            });

        case actionTypes.CLEAR_PROFESSION_LIST:
            return state.merge({
                professionsWorkforSelfEmployed: [],
                professionsWorkforEmployed: [],
            });

        case actionTypes.CLEAR_SUBCATEGORIES_PROFESSION_LIST:
            return state.merge({
                professionsWorkforSelfEmployedSC: [],
                professionsWorkforEmployedSC: [],
            });

        case actionTypes.CLEAR_CATEGORIES_LIST:
            return state.merge({
                professionAllCategoriesCNO: [],
                professionAllCategoriesCNAE: [],
            });

        case actionTypes.GET_PROFESSION_CATEGORIES_CNO:
            var professionAllCategoriesCNO = state.get('professionAllCategoriesCNO');
            action.data.map(function (value) {
                professionAllCategoriesCNO = professionAllCategoriesCNO.push(
                    Immutable.Map({
                        value: value.id,
                        label: value.description,
                    })
                );
            });
            return state.merge({
                professionAllCategoriesCNO,
                isLoadingCnoSubCategories: false,
            });

        case actionTypes.GET_PROFESSION_CATEGORIES_CNAE:
            var professionAllCategoriesCNAE = state.get('professionAllCategoriesCNAE');
            action.data.map(function (value) {
                professionAllCategoriesCNAE = professionAllCategoriesCNAE.push(
                    Immutable.Map({
                        value: value.id,
                        label: value.description,
                    })
                );
            });
            return state.merge({
                professionAllCategoriesCNAE,
                isLoadingCnaeSubCategories: false,
            });

        default:
            return state;
    }
};

module.exports = optionsReducer;
